// Floating Back / Forward controls rendered by snippets/page-nav.liquid.
const nav = document.querySelector('[data-page-nav]');
if (nav) {
  const back = nav.querySelector('[data-page-nav-back]');
  const forward = nav.querySelector('[data-page-nav-forward]');
  const api = window.navigation;

  const sameSiteReferrer = () => {
    try {
      return document.referrer && new URL(document.referrer).origin === location.origin;
    } catch {
      return false;
    }
  };

  const setDisabled = (el, disabled) => {
    if (!el) return;
    if (disabled) el.setAttribute('aria-disabled', 'true');
    else el.removeAttribute('aria-disabled');
  };

  const refresh = () => {
    const canBack = api && 'canGoBack' in api ? api.canGoBack : history.length > 1 || sameSiteReferrer();
    const canForward = api && 'canGoForward' in api ? api.canGoForward : true;
    setDisabled(back, !canBack);
    setDisabled(forward, !canForward);
  };

  back?.addEventListener('click', () => {
    if (back.getAttribute('aria-disabled') === 'true') return;
    history.back();
  });
  forward?.addEventListener('click', () => {
    if (forward.getAttribute('aria-disabled') === 'true') return;
    history.forward();
  });

  refresh();
  window.addEventListener('pageshow', refresh);
  api?.addEventListener?.('currententrychange', refresh);
}
